import React from "react";
import firebase from "firebase";
import axios from "axios";

///Fetches student data files by statistic choice
//Note: Statistic choice and database choice both have the same values and are needed this way
//For Admin side menu to work properly
export async function FetchStatisticData(classLevel, statisticChoice){
    let promise = new Promise(async(resolve) => {
        if(statisticChoice === 'pronunciationAssignments'){
            const studentFile = firebase.storage().ref().child('students/10' + classLevel + '/pronunciationData.json');
            studentFile.getDownloadURL()
                .then(url => axios.get(url))
                .then(res => {
                    resolve(res.data)
                });
        }
        if(statisticChoice === 'dialogFCAssignments'){
            const studentFile = firebase.storage().ref().child('students/10' + classLevel + '/dialogFCData.json');
            studentFile.getDownloadURL()
                .then(url => axios.get(url))
                .then(res => {
                    resolve(res.data)
                });
        }
        if(statisticChoice === 'translationFCAssignments'){
            const studentFile = firebase.storage().ref().child('students/10' + classLevel + '/translationFCData.json');
            studentFile.getDownloadURL()
                .then(url => axios.get(url))
                .then(res => {
                    resolve(res.data)
                });
        }
        if(statisticChoice === 'dialogAssignments'){
            const studentFile = firebase.storage().ref().child('students/10' + classLevel + '/dialogData.json');
            studentFile.getDownloadURL()
                .then(url => axios.get(url))
                .then(res => {
                    resolve(res.data)
                });
        }
        if(statisticChoice === 'quizAssignments'){
            const studentFile = firebase.storage().ref().child('students/10' + classLevel + '/quizData.json');
            studentFile.getDownloadURL()
                .then(url => axios.get(url))
                .then(res => {
                    resolve(res.data)
                });
        }
    });
    return promise;
}
